module.exports = __webpack_public_path__ + "static/media/45.954c28e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/45.jpg
// module id = 735
// module chunks = 0